/**
 * The request of a this_and_future or entire_series edit (#2119). Only a changed status goes
 * to the scope (D3): sending the edited shift's unchanged status would overwrite the statuses
 * of the other shifts. Only the entire series takes a recurrence (D1).
 */
import { shifts_UpdateShiftSeriesRequest } from '@/api/models/shifts_UpdateShiftSeriesRequest';
import { toEnumMember } from '@/lib/enumMember';
import type { UpdateShiftFormData } from '@/schemas/shiftSchemas';
import type { UpdateShiftSeriesRequest } from '@/types/shifts';

export interface SeriesRecurrenceChange {
  recurrenceType: string;
  repetitions: number;
}

export function buildSeriesUpdateRequest(
  scope: shifts_UpdateShiftSeriesRequest.update_scope,
  data: UpdateShiftFormData,
  originalStatus: string | undefined,
  recurrence: SeriesRecurrenceChange | null
): UpdateShiftSeriesRequest {
  const request: UpdateShiftSeriesRequest = {
    update_scope: scope,
    start_time: data.startTime,
    end_time: data.endTime,
    break_minutes: data.breakMinutes,
    break_start: data.breakStart && data.breakStart !== '' ? data.breakStart : undefined,
    break_end: data.breakEnd && data.breakEnd !== '' ? data.breakEnd : undefined,
    // The DTO's enums are nominal; the form's literal unions carry the same values, so a
    // membership lookup crosses the boundary without a cast.
    shift_type:
      toEnumMember(shifts_UpdateShiftSeriesRequest.shift_type, data.shiftType) ??
      shifts_UpdateShiftSeriesRequest.shift_type.REGULAR,
    group_ids: data.groupIds,
    notes: data.notes || undefined,
    current_updated_at: data.currentUpdatedAt,
    status: data.status !== originalStatus ? toEnumMember(shifts_UpdateShiftSeriesRequest.status, data.status) : undefined,
  };
  if (scope === shifts_UpdateShiftSeriesRequest.update_scope.ENTIRE_SERIES && recurrence) {
    // `RecurrenceType.NONE` has no DTO counterpart: "no recurrence" is an omitted field.
    request.recurrence_type = toEnumMember(shifts_UpdateShiftSeriesRequest.recurrence_type, recurrence.recurrenceType);
    request.repetitions = recurrence.repetitions;
  }
  return request;
}
